<template>
  <div id="record-display-wrapper">
    <iframe v-if="mime === 'pdf'" :src="`https://mozilla.github.io/pdf.js/web/viewer.html?file=${previewUrl(record.location)}`" width="100%" :style="iframeStyle"></iframe>
    <iframe v-else-if="mime === 'microsoft'" :src="`https://view.officeapps.live.com/op/embed.aspx?src=${previewUrl(record.location)}&embedded=true`" width="100%" :style="iframeStyle"></iframe>
    <img v-else-if="mime === 'image'" :src="previewUrl(record.location)" class="preview-img" />
    <div v-else class="empty-state">
      <img alt="No preview" src="../../assets/preview_icon.svg">
      <br/>
      {{ $t('record.record_display.no_preview') }}
      <br/>
      <a disposition="attachment" :download="true" :href="previewUrl(record.location)" class="btn btn-primary">
        {{ $t('record.record_display.download_file') }}
      </a>
    </div>
  </div>
</template>

<script>
  const MICROSOFT_MIMES = [
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel.sheet.macroenabled.12'
  ]

  const IMAGE_MIMES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
  ]

  export default {
    props: ['record'],
    computed: {
      mime() {
        if (this.$props.record.mime_type === 'application/pdf')
          return 'pdf'
        else if (MICROSOFT_MIMES.indexOf(this.$props.record.mime_type) > -1)
          return 'microsoft'
        else if (IMAGE_MIMES.indexOf(this.$props.record.mime_type) > -1)
          return 'image'
        else
          return 'unknown'
      },
      iframeStyle() {
        return {
          border: 0,
          position: 'static',
          'z-index': 0
        }
      }
    }
  }
</script>

<style scoped>
  #record-display-wrapper {
    width: 50vw;
    background: #EEEEEE;
    height: calc(100vh - 120px);
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
  }

  #record-display-wrapper .empty-state {
    text-align: center;
    font-size: 15px;
    font-weight: bold;
  }

  #record-display-wrapper .empty-state .btn-primary, #record-display-wrapper .empty-state img {
    margin-top: 10px;
    margin-bottom: 30px;
    padding-left: 40px;
    padding-right: 40px;
  }

  iframe {
    height: calc(100vh - 120px);
  }

  img.preview-img {
    min-width: 100px;
    max-width: 90%;
    max-height: 100%;
    height: auto;
    margin-top: 30px;
  }
</style>
